import { EmailArrowLeftOutlineIcon } from './EmailArrowLeftOutlineIcon';

/**
 * author: Michael Richins
 * id 2DF250FF-F6DC-4C7D-A5A6-AFEAEBAD45F4
 * name email-arrow-left-outline
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-arrow-left-outline.svg
 * tags
 */
export const EmailReceiveOutlineIcon = EmailArrowLeftOutlineIcon;
export default EmailReceiveOutlineIcon